<script>
	import { afterUpdate, onMount, tick } from "svelte";

	export let row = {};
	export let key = "";
	export let className = "";

	const VIEWPORT_MARGIN = 8;

	let textEl;
	let bubbleEl;
	let isTruncated = false;
	let showTooltip = false;
	let tooltipTop = 0;
	let tooltipLeft = 0;

	function checkTruncated() {
		if (!textEl) return;
		isTruncated =
			textEl.scrollHeight > textEl.clientHeight ||
			textEl.scrollWidth > textEl.clientWidth;
	}

	async function handleMouseEnter() {
		if (!isTruncated || !textEl) return;
		const rect = textEl.getBoundingClientRect();
		tooltipTop = rect.bottom + 4;
		tooltipLeft = rect.left;
		showTooltip = true;

		await tick();
		if (!bubbleEl) return;
		const bubbleRect = bubbleEl.getBoundingClientRect();

		tooltipLeft = Math.min(
			Math.max(tooltipLeft, VIEWPORT_MARGIN),
			window.innerWidth - VIEWPORT_MARGIN - bubbleRect.width
		);
		if (rect.bottom + bubbleRect.height + 4 > window.innerHeight) {
			tooltipTop = rect.top - bubbleRect.height - 4;
		}
	}

	function handleMouseLeave() {
		showTooltip = false;
	}

	onMount(checkTruncated);
	afterUpdate(checkTruncated);
</script>

<span
	class="truncate-tooltip-container"
	on:mouseenter={handleMouseEnter}
	on:mouseleave={handleMouseLeave}
>
	<span class={className} bind:this={textEl}>{row[key] || "-"}</span>
</span>
{#if showTooltip}
	<span
		class="truncate-tooltip-bubble"
		bind:this={bubbleEl}
		style="top: {tooltipTop}px; left: {tooltipLeft}px;"
	>
		{row[key] || "-"}
	</span>
{/if}

<style>
	.truncate-tooltip-container {
		display: block;
	}

	.truncate-tooltip-bubble {
		position: fixed;
		z-index: 1000;
		background-color: black;
		color: #fff;
		padding: 6px 10px;
		border-radius: 6px;
		white-space: normal;
		width: max-content;
		max-width: 320px;
	}
</style>
